module.exports = __webpack_public_path__ + "static/footer-power-drawing-2-2f167e80f5f06115e3bd5fdf5fbe8c30.png";